export default function removeLocalStorageData() {
  localStorage.setItem("selectLocation", "");
  localStorage.setItem("selectProcess", "");
  localStorage.setItem("selectScore", "");
  localStorage.setItem("selectStatus", "");
  localStorage.setItem("numberSearch", "");
  localStorage.setItem("selectSource", "");
  localStorage.setItem("page", "");
  localStorage.setItem("selectInterviewRound", "Application_Received");
  localStorage.setItem("trf_ids", "");
  localStorage.setItem("interviewRoundLevel", "");
  localStorage.setItem("designation", "");
}
